<template>
  <div class="container">
    <div
      style="
        background: white;
        border-radius: 10px;
        min-height: 400px;
        text-align: center;
        margin: 15px auto;
        padding: 35px 45px;
        max-width: 300px;
      "
    >
      <img :src="'./img/shop/success_mark.png'" alt="" style="width: 100%" />
      <h3 style="color: green">Payment Successfully</h3>

      <br />
      <a
        href="line://app/1574678121-rAaOdkxd"
        class="btn btn-primary btn-lg"
        @click="close"
        >Close</a
      >
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close: function () {},
  },
};
</script>

<style scoped></style>
